import React, { Component } from "react";
import axios from "axios";
import Constants from "Helpers/Constants";
import init from "Helpers/WindowToken";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Navigate } from "react-router-dom";

import {
  Card,
  Grid,
  TextField,
  Select,
  MenuItem,
} from "@mui/material";

import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";
import MDSnackbar from "components/MDSnackbar";

import MediaPickerModal from "Main/Modals/MediaModal";

export default class UpdateAchiever extends Component {
  state = {
    achiever_id: "",
    achiever_name: "",
    rank: "",
    description: "",
    level_id: "",
    course_id: "",
    img_alt_text: "",

    levels: [],
    courses: [],

    selectedImage: null,
    showMediaModal: false,

    loading: false,
    notification: false,
    message: "",
    notiColor: "success",
    redirect: false,
  };

  componentDidMount() {
    this.getDropdownData();
    this.getSingleAchiever();
  }

  // ✅ DROPDOWNS
  getDropdownData = async () => {
    try {
      const [levels, courses] = await Promise.all([
        axios.post(Constants.getUrls.getAllLevels, { page: 1, limit: 100 }),
        axios.post(Constants.getUrls.getAllCourses, { page: 1, limit: 100 }),
      ]);

      this.setState({
        levels: levels.data.data.rows || [],
        courses: courses.data.data.rows || [],
      });
    } catch (err) {
      console.log(err);
    }
  };

  // ✅ GET SINGLE
  getSingleAchiever = async () => {
    const id = window.location.pathname.split("/")[2];

    try {
      const resp = await axios.post(
        Constants.getUrls.getAchieversDetails,
        { id }
      );

      if (resp.data.status) {
        const data = resp.data.data;

        this.setState({
          achiever_id: data.id,
          achiever_name: data.achiever_name,
          rank: data.rank,
          description: data.description,
          level_id: data.level_id,
          course_id: data.course_id,
          img_alt_text: data.img_alt_text || "",

          selectedImage: data.image_id
            ? {
                id: data.image_id,
                image_path: data.image_path,
              }
            : null,
        });
      }
    } catch (err) {
      console.log(err);
    }
  };

  handleInput = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  // ✅ UPDATE
  handleSubmit = async (e) => {
    e.preventDefault();

    const {
      achiever_id,
      achiever_name,
      rank,
      description,
      level_id,
      course_id,
      selectedImage,
      img_alt_text,
    } = this.state;

    if (
      !achiever_name ||
      !rank ||
      !level_id ||
      !course_id ||
      !selectedImage
    ) {
      return this.setState({
        notification: true,
        message: "All fields are required!",
        notiColor: "warning",
      });
    }

    if (init() !== "success") {
      window.location.assign("/signin");
      return;
    }

    const payload = {
      id: achiever_id,
      achiever_name,
      rank,
      description,
      level_id,
      course_id,
      image_id: selectedImage.id,
      role_id: 1,
      img_alt_text,
    };

    this.setState({ loading: true });

    try {
      const resp = await axios.post(
        Constants.putUrls.updateAchiever,
        payload
      );

      this.setState({
        notification: true,
        message: resp.data.message || "Updated successfully!",
        notiColor: "success",
        loading: false,
      });

      setTimeout(() => {
        this.setState({ redirect: true });
      }, 1500);
    } catch (err) {
      this.setState({
        notification: true,
        message:
          err?.response?.data?.message || "Something went wrong!",
        notiColor: "warning",
        loading: false,
      });
    }
  };

  render() {
    if (this.state.redirect) return <Navigate to="/achievers" />;

    return (
      <DashboardLayout>
        <DashboardNavbar />

        <MDBox pt={6} pb={3}>
          <Card>

            {/* 🔥 HEADER */}
            <MDBox
              mx={2}
              mt={-6}
              py={3}
              px={2}
              bgColor="info"
              borderRadius="lg"
            >
              <MDTypography variant="h6" color="white">
                Update Achiever
              </MDTypography>
            </MDBox>

            <MDBox py={3} px={2}>
              <form onSubmit={this.handleSubmit}>
                <Grid container spacing={2}>

                  <Grid item sm={6}>
                    <TextField
                      label="Achiever Name"
                      name="achiever_name"
                      value={this.state.achiever_name}
                      onChange={this.handleInput}
                      fullWidth
                    />
                  </Grid>

                  <Grid item sm={6}>
                    <TextField
                      label="Rank"
                      name="rank"
                      value={this.state.rank}
                      onChange={this.handleInput}
                      fullWidth
                    />
                  </Grid>

                  <Grid item sm={6}>
                    <Select
                      name="level_id"
                      value={this.state.level_id}
                      onChange={this.handleInput}
                      displayEmpty
                      style={{
                        width: "100%",
                        height: "45px",
                        color: "#fff",
                      }}
                    >
                      <MenuItem value="">Select Level</MenuItem>
                      {this.state.levels.map((l) => (
                        <MenuItem key={l.id} value={l.id}>
                          {l.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  <Grid item sm={6}>
                    <Select
                      name="course_id"
                      value={this.state.course_id}
                      onChange={this.handleInput}
                      displayEmpty
                      style={{
                        width: "100%",
                        height: "45px",
                        color: "#fff",
                      }}
                    >
                      <MenuItem value="">Select Course</MenuItem>
                      {this.state.courses.map((c) => (
                        <MenuItem key={c.id} value={c.id}>
                          {c.course_name}
                        </MenuItem>
                      ))}
                    </Select>
                  </Grid>

                  <Grid item sm={6}>
                    <MDButton
                      variant="contained"
                      color="info"
                      onClick={() =>
                        this.setState({ showMediaModal: true })
                      }
                    >
                      Change Image
                    </MDButton>

                    {this.state.selectedImage && (
                      <img
                        src={
                          Constants.imageDomain +
                          this.state.selectedImage.image_path
                        }
                        style={{
                          width: 80,
                          height: 80,
                          marginTop: 10,
                          borderRadius: 6,
                        }}
                      />
                    )}
                  </Grid>

                  <Grid item sm={6}>
                    <TextField
                      label="Image Alt Text"
                      name="img_alt_text"
                      value={this.state.img_alt_text}
                      onChange={this.handleInput}
                      fullWidth
                    />
                  </Grid>

                  <Grid item sm={12}>
                    <TextField
                      label="Description"
                      name="description"
                      value={this.state.description}
                      onChange={this.handleInput}
                      multiline
                      rows={4}
                      fullWidth
                    />
                  </Grid>

                  <Grid item sm={12}>
                    <MDButton type="submit" variant="contained" color="info">
                      {this.state.loading
                        ? "Updating..."
                        : "Update Achiever"}
                    </MDButton>
                  </Grid>

                </Grid>
              </form>
            </MDBox>

            <MDSnackbar
              color={this.state.notiColor}
              title="Achiever"
              content={this.state.message}
              open={this.state.notification}
            />

            <MediaPickerModal
              visible={this.state.showMediaModal}
              multiple={false}
              onClose={() =>
                this.setState({ showMediaModal: false })
              }
              onSelect={(images) => {
                this.setState({
                  selectedImage: images[0],
                  showMediaModal: false,
                });
              }}
            />
          </Card>
        </MDBox>
      </DashboardLayout>
    );
  }
}